import { ServiceResponse } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { ResponseMessage } from '@sdbn/common';
import { Row } from '@sdbn/common';
import { ColumnType } from '@sdbn/common';
import { SelectionType } from '@sdbn/common';
import { TmcTableModel } from '@sdbn/common';
import { TranslationService } from '@sdbn/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { LinkableTransport, LinkVehicleWithTransport, TransportLinkage } from '../link-transports.model';

export class Timeframe {
  timeframeDate: string;
  timeframe: number;
  initialselection: boolean;
}

@Component({
    selector: 'app-link-transports-dialog',
    templateUrl: './link-transports-dialog.component.html',
    styleUrls: ['./link-transports-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class LinkTransportsDialogComponent implements OnInit {

  /** Used for Timeframe selection */
  availableTimeframes = new Array<Timeframe>();
  selectedTimeFrame = -1;

  /** page 0 = transport selection, page 1 == timeframe selection */
  currentPage = 0;

  responseMessages: ResponseMessage[];
  isLoading = false;
  tableModel: TmcTableModel = new TmcTableModel();

  constructor(
    public dialogRef: MatDialogRef<LinkTransportsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appServerAPI: AppServerAPI,
    public translationService: TranslationService) {

    this.tableModel.selectionType = data.details.type === 'VEHICLE' ? SelectionType.SINGLE : SelectionType.MULTIPLE;
    this.tableModel.sortable = true;
    this.tableModel.filterable = true;

    const prefix = 'tmc-yard.ui.link-transports-dialog.table.column.';
    this.tableModel.columnDefinitions = [
      { id: 'carrier', name: 'carrier', visible: true, type: ColumnType.STRING, translationKey: prefix + 'carrier' },
      { id: 'cargo', name: 'cargo', visible: true, type: ColumnType.STRING, translationKey: prefix + 'cargo' },
      { id: 'planningDate', name: 'planningDate', visible: true, type: ColumnType.STRING, translationKey: prefix + 'planningDate' }
    ];

    this.tableModel.setRows(this.convertToTableRows(data.details.linkableTransports));
  }

  ngOnInit() { }

  private convertToTableRows(transports: LinkableTransport[]): Row[] {
    const rows: Row[] = [];
    for (const t of transports) {
      const row: Row = new Row();
      row.id = t.id + '';
      row.values = {
        id: t.id, carrier: t.carrier, cargo: t.cargo, planningDate: t.planningDate,
        timeframeDate: t.timeframeDate, timeframe: t.timeframe
      };

      row.sortValues = { planningDate: t.planningDateSortValue };

      if (t.cargo != null && t.cargo.length > 0) {
        row.columnStyles.set('cargo', ['multiple-lines']);
      }

      rows.push(row);
    }

    return rows;
  }

  public isCloseDialogDisabled() {
    return false;
  }

  public isShowTimeFrameSelection() {
    if (this.isLoading) {
      return true;
    }
    return this.tableModel.selectedRows.length === 0;
  }

  public showTransportSelection() {
    this.responseMessages = [];
    this.currentPage = 0;
  }

  public showTimeFrameSelection() {
    if (this.tableModel.selectedRows.length > 0) {

      this.availableTimeframes = new Array<Timeframe>();
      if (this.data.details.timeframe != null) {

        this.availableTimeframes.push(
          { timeframeDate: this.data.details.timeframeDate, timeframe: this.data.details.timeframe, initialselection: true }
        );
      }

      let selectionNeeded = false;
      for (const r of this.tableModel.selectedRows) {
        if (r.values.timeframe != null) {
          if (this.availableTimeframes.filter(tf => tf.timeframeDate === r.values.timeframeDate).length === 0) {
            this.availableTimeframes.push(
              { timeframeDate: r.values.timeframeDate, timeframe: r.values.timeframe, initialselection: false }
            );
            selectionNeeded = true;
          }
        }
      }

      // sort timeframes baed on date (earliest first) and preselect the first entry of timeframes
      if (this.availableTimeframes.length > 0) {
        this.availableTimeframes.sort((a, b) => {
          if (a.timeframe < b.timeframe) {
            return -1;
          } else if (a.timeframe > b.timeframe) {
            return 1;
          }
          return 0;
        });
        this.availableTimeframes[0].initialselection = true;
        this.selectedTimeFrame = this.availableTimeframes[0].timeframe;
      }

      // show timeframe component
      this.currentPage = 1;
    }
  }

  public linkTransports() {

    this.isLoading = true;
    this.responseMessages = [];

    const link = new TransportLinkage();
    link.timeframe = this.selectedTimeFrame;

    for (const r of this.tableModel.selectedRows) {
      link.linkedTransports.push({ id: + r.id });
    }

    link.targetTransport = { id: this.data.details.id };
    this.appServerAPI.execute<ServiceResponse>('/client/control/linktransports/link', link).subscribe(
      response => {
        if (ServiceResponse.isFailed(response)) {
          this.responseMessages = response.responseMessages;
        } else {
          this.dialogRef.close();
        }
        this.isLoading = false;
      }, error => {
        console.error('Error linking Transports');
        this.isLoading = false;
      }
    );
  }

  public closeDialog() {
    this.dialogRef.close();
  }


  public linkVehicleWithTransport() {

    console.log('linking vehicle with transport', this.data.details.id,this.tableModel.selectedRows);

    if (this.tableModel.selectedRows.length == 0) {
      return;
    }

    this.isLoading = true;
    this.responseMessages = [];

    const link = new LinkVehicleWithTransport();
    link.transportId = +this.tableModel.selectedRows[0].id;
    link.vehicleId = this.data.details.id;

    this.appServerAPI.execute<ServiceResponse>('/client/control/linktransports/linkVehicleWithTransport', link).subscribe(
      response => {
        if (ServiceResponse.isFailed(response)) {
          this.responseMessages = response.responseMessages;
        } else {
          this.dialogRef.close();
        }
        this.isLoading = false;
      }, error => {
        console.error('Error linking Transports');
        this.isLoading = false;
      }
    );

  }
}
